module.exports = __webpack_public_path__ + "img/logo.69e36076.png";